import './App.css';
import CallLineItem from './CallLineItem';

function Calls({ calls, searchText }) {
  return (
    <div className="py-8">
      {calls.map(call => <CallLineItem key={call.id} call={call} searchText={searchText} />)}
    </div>
  );
}

export default Calls;
